'use client';

import { useEffect } from 'react';
import { DisconnectBanner } from './DisconnectBanner';
import { DisconnectOverlay } from './DisconnectOverlay';
import { IdleWarningModal } from './IdleWarningModal';
import { useActivityTracker } from '@/lib/session-guard/useActivityTracker';
import { useIdleTimer } from '@/lib/session-guard/useIdleTimer';
import { useAuthStore } from '@/stores/authStore';

export function SessionGuard() {
  const isAuthenticated = useAuthStore((s) => s.status === 'authenticated');

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && (e.key === 'L' || e.key === 'l')) {
        e.preventDefault();
        void useAuthStore.getState().actions.forceLogout('manual');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return isAuthenticated ? <SessionGuardActive /> : null;
}

// Inner component that runs the hooks only when authenticated.
// Hooks attached/detached as auth status flips, so listeners go away on logout.
function SessionGuardActive() {
  useActivityTracker();
  useIdleTimer();
  return (
    <>
      <DisconnectBanner />
      <DisconnectOverlay />
      <IdleWarningModal />
    </>
  );
}
